var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcStar48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.224 8.308c1.538-3.077 6.014-3.077 7.552 0l3.58 7.164 8.048 1.162c3.437.496 4.812 4.631 2.332 7.016l-5.84 5.618 1.374 7.911c.585 3.37-3.03 5.933-6.113 4.332L24 37.794l-7.157 3.717c-3.082 1.601-6.698-.961-6.113-4.332l1.374-7.911-5.84-5.618c-2.48-2.384-1.105-6.52 2.332-7.016l8.047-1.162z",
  clipRule: "evenodd"
})));
export default SvgIcStar48;